<script setup lang="ts">
import { addHttpsToUrl } from '@/components/ui/TextareaWithVars/utils'

const route = useRoute()
const { t } = useI18n()
const linkId = route.params.linkId

const title = computed(() => {
  return t(`pages.message.previewLinkPage.${linkId}.title`)
})

const description = computed(() => {
  return t(`pages.message.previewLinkPage.${linkId}.description`)
})

const rewardName = computed(() => {
  return route.query.reward as string
})

const customLink = computed(() => {
  return addHttpsToUrl(route.query.link as string)
})

const closePreview = () => {
  window.close()
}
</script>

<template>
  <div class="p-4 w-screen h-screen flex flex-col items-center justify-center bg-[#fffcf1] anim-opacity">
    <div
      class="fixed -top-[200px] md:-top-[25rem] -right-[200px] md:-right-[15rem] max-w-[800px] max-h-[800px] min-w-[400px] min-h-[400px] w-1/2 aspect-square big-blur-pink"
    ></div>
    <div
      class="fixed -bottom-[200px] md:-bottom-[25rem] -left-[200px] md:-left-[15rem] max-w-[800px] max-h-[800px] min-w-[400px] min-h-[400px] w-1/2 aspect-square big-blur-yellow"
    ></div>

    <div class="w-full max-w-md border rounded-xl bg-white">
      <div class="flex flex-col p-4 border-b">
        <h1 class="font-medium text-lg">{{ title }}</h1>
      </div>
      <div class="flex flex-col gap-4 p-4">
        <p>{{ description }}</p>
        <div v-if="rewardName" class="bg-muted rounded-lg px-4 py-3 flex-col gap-2 text-foreground-secondary">
          <p class="text-sm">{{ t('pages.message.previewLinkPage.rewardName') }}</p>
          <p class="font-semibold">{{ rewardName }}</p>
        </div>

        <div v-if="customLink" class="bg-muted rounded-lg px-4 py-3 flex-col gap-2 text-foreground-secondary">
          <p class="text-sm">{{ t('pages.message.previewLinkPage.previewLink') }}</p>
          <a class="font-semibold underline" :href="customLink">{{ customLink }}</a>
        </div>
        <Button variant="default-primary" @click="closePreview">{{ t('global.words.close') }}</Button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.anim-opacity {
  animation: anim-opacity 0.3s ease-in-out forwards;
}
.big-blur-yellow {
  background-image: radial-gradient(circle closest-side at 50% 50%, #ffeda8, #ffeda800);
}

.big-blur-pink {
  background-image: radial-gradient(circle closest-side at 50% 50%, #f5dafa, #f5dafa00);
}

@keyframes anim-opacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
